import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ArticlesService } from '../../../services/articles.service';
import { Multitenant } from '../../../services/multitenant.provider';
import { MetaProvider } from '../../../services/meta.provider';
import { Book } from '../../../models/book.model';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { PopUp } from '../../../models/popup.model';
import { AuthProvider } from '../../../services/auth.provider';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { sharedItems } from 'src/app/shared/utils';

@Component({
  selector: 'app-book-month',
  templateUrl: 'book-month.html',
  styleUrls: ['book-month.scss']
})
export class BookMonthPage implements OnInit {
  public books: Array<Book>;
  public error: string;
  public themeClass: string;
  public authenticated: boolean;
  public isActivePage: string;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();

  constructor(
    private router: Router,
    private articlesService: ArticlesService,
    private multiTenant: Multitenant,
    private meta: MetaProvider,
    private ga: GaEventTrackerProvider,
    private auth: AuthProvider,
    private popUpService: PopUpService
  ) {}

  ngOnInit() {
    this.themeClass = this.multiTenant.getDomainClass();
  }

  ionViewDidEnter() {
    this.authenticated = false;
    this.getBooks(this.themeClass);
    this.isActivePage = 'menu';
    this.meta.clearHead();

    if ( !this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  getBooks(newspaper: string) {
    this.articlesService.getBookOfMonthList(newspaper).subscribe(
      response => this.books = response,
      () => this.error = ' Vos identifiants ne sont pas reconnus'
    );
  }

  showTempPopUp() {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }

  navigateToDetail(book: Book) {
    // push another page onto the navigation stack
    // causing the nav controller to transition to the new page
    // optional data can also be passed to the pushed page.
    // this.router.navigate(['actu-livres', book.book_slug], { queryParams: { book: JSON.stringify(book) } });
    this.router.navigate(['actu-livres', book.book_slug]);
  }


  // eslint-disable-next-line @typescript-eslint/naming-convention
  goToExtract(url: string, book_title: string) {
    this.ga.trackEvent(this.themeClass, 'Lire un extrait', book_title, 0);
    window.open(url, '_blank');
  }

  getInclude(book) {
    if ( !this.auth.isAuthenticated() || (this.auth.isAuthenticated() && this.auth.getActiveProfile() === 'Children') ) {
      return sharedItems(book.book_newspaper);
    } else {
      return ['facebook', 'twitter', 'email', 'whatsapp'];
    }
  }
}
